
import { granjaApi } from "../../api";
import { useEncubadoraStore } from "../../store";

import Swal from "sweetalert2";



export const startIncubadoraXID = async(id) => {
    try {
        const { data } = await granjaApi.get(`/encubadora/xid/${id}`);
        return data.data;
    } catch (error) {
        Swal.fire('Error', error.response.data.msg, 'error');
        console.log(error)
    }
}



export const startListadoEncubadora = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);
        const { data } = await granjaApi.get('/encubadora', { params });
        useEncubadoraStore.setState({ totalEncubadora: data.total });

        return data.data;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const startSavingEncubadora = async(encubadora) => {
    try {
        if( encubadora.id ){
            await granjaApi.put(`/encubadora/${ encubadora.id }`, encubadora );
            Swal.fire('Exitoso', 'Incubadora Actualizada', 'success');
        }else {
            await granjaApi.post('/encubadora/new', encubadora);
            Swal.fire('Exitoso', 'Incubadora Creada', 'success');
            return true;
        }
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data.msg, 'error');
        return false;
    }
} 


    

